import { AxiosInstance } from 'axios';

const formulaSnapshotsServices = (instance: AxiosInstance) => {
  // Crear snapshot manual
  const createSnapshot = (formulaId: number, reason: string) =>
    instance.post(`/formula-snapshots/${formulaId}`, { reason });

  // Obtener historial optimizado
  const getHistory = (formulaId: number) =>
    instance.get(`/formula-snapshots/${formulaId}/history-frontend`);

  // Obtener historial completo (datos raw) - DEPRECATED
  const getHistoryRaw = (formulaId: number) =>
    instance.get(`/formula-snapshots/${formulaId}/history`);

  // Comparar con último snapshot
  const compareWithLast = (formulaId: number) =>
    instance.get(`/formula-snapshots/${formulaId}/compare`);

  // Procesar todas las fórmulas
  const processAll = () => instance.post('/formula-snapshots/process-comparison');

  // Copiar todos los datos
  const copyAllData = () => instance.post('/formula-snapshots/copy-all-data');

  // Obtener base por volumen para una fórmula
  const getBaseByVolume = (formulaId: number) =>
    instance.get(`/base-formula?include=material&id_formula=${formulaId}`);

  return {
    createSnapshot,
    getHistory,
    getHistoryRaw,
    compareWithLast,
    processAll,
    copyAllData,
    getBaseByVolume,
  };
};

export default formulaSnapshotsServices;
